jQuery.noConflict();

(function () {
  jQuery(document).ready(function ($) {
    const oneYear = 365;
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + oneYear);

    function ordinal(day) {
      if (day > 3 && day < 21) return `${day}th`;

      switch (day % 10) {
        case 1:
          return `${day}st`;
        case 2:
          return `${day}nd`;
        case 3:
          return `${day}rd`;
        default:
          return `${day}th`;
      }
    }

    function checkBookingReady() {
      const service = $('.service-dropdown').val();
      const isDateSelected = $('.selected-date-text').text() !== 'Select a date';
      const isTimeSelected = $('.selected-time-text').text() !== 'Select a time';
      const isReady = Boolean(service && isDateSelected && isTimeSelected);

      $('.btn--continue').toggleClass('active', isReady).prop('disabled', !isReady);

      if (isReady) {
        updateHulkFormBookingFields();
      }
    }

    function renderSummary() {
      $('.mmAppointment').text($.cookie('mm-virtual-appointment'));
      $('.mmAppointmentTime').text($.cookie('mm-virtual-approx-time'));
      $('.formattedDateOnly').text($.cookie('mm-virtual-date'));
      $('.formattedTimeOnly').text($.cookie('mm-virtual-time'));
      $('.mm-customer-name').text(`${$.cookie('mm-customer-fname') || ''} ${$.cookie('mm-customer-lname') || ''}`.trim());
      $('.mm-customer-email').text($.cookie('mm-customer-email'));
      $('.mm-customer-mobile').text($.cookie('mm-customer-mobile'));
    }

    function saveInputValue(inputId, cookieName) {
      let inputValue = $.cookie(cookieName);

      if (inputValue) {
        $(inputId).val(inputValue);
      }

      $(inputId).on('input', function () {
        inputValue = $(this).val();
        $.cookie(cookieName, inputValue, { expires: expirationDate });
      });
    }

    function setVirtualBookingSourceCookie() {
      const exp = new Date(Date.now() + 365 * 864e5).toUTCString();
      document.cookie = `mm-form-source=virtual-booking; expires=${exp}; path=/`;
    }

    function getBookingFormData() {
      const serviceWhen = [$.cookie('mm-virtual-date'), $.cookie('mm-virtual-time')].filter(Boolean).join(', ');
      const selectedService = $.cookie('mm-virtual-appointment') || '';

      return {
        source: 'Virtual Appointment',
        appointment_type: 'Virtual Appointment',
        pick_a_service: selectedService,
        service_when: serviceWhen,
        Source: 'Virtual Appointment',
        'Appointment Type': 'Virtual Appointment',
        'Pick a Service': selectedService,
        When: serviceWhen,
        when: serviceWhen
      };
    }

    function updateHulkFormBookingFields() {
      const $hulkFrame = $('.pxFormGenerator iframe');
      if (!$hulkFrame.length) return;

      const currentSrc = $hulkFrame.attr('src');
      if (!currentSrc) return;

      const iframeUrl = new URL(currentSrc, window.location.href);
      const bookingData = getBookingFormData();
      const bookingSignature = JSON.stringify(bookingData);
      if ($hulkFrame.attr('data-booking-signature') === bookingSignature) return;

      const referrerUrl = new URL(iframeUrl.searchParams.get('referrer_url') || window.location.href, window.location.href);

      Object.keys(bookingData).forEach(function (key) {
        iframeUrl.searchParams.set(key, bookingData[key]);
        referrerUrl.searchParams.set(key, bookingData[key]);
      });

      iframeUrl.searchParams.set('referrer_url', referrerUrl.toString());

      const nextSrc = iframeUrl.toString();
      if (nextSrc !== currentSrc) {
        $hulkFrame.attr('data-booking-signature', bookingSignature);
        $hulkFrame.attr('src', nextSrc);
      } else {
        $hulkFrame.attr('data-booking-signature', bookingSignature);
      }
    }

    $(document).on('change', '.service-dropdown', function () {
      const selectedService = $(this).val();
      const selectedTime = $(this).find(':selected').data('time');

      if (!selectedService) return;

      $.cookie('mm-virtual-appointment', selectedService, { expires: expirationDate });
      $.cookie('mm-virtual-approx-time', selectedTime, { expires: expirationDate });

      checkBookingReady();
    });

    $(document).on('click', '.btn--date-select', function () {
      const dateValue = $('#datetimepicker').datetimepicker('getValue');
      if (!dateValue) return;

      const appointmentDate = new Date(dateValue);
      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ];
      const dayOfWeek = appointmentDate.toLocaleString('en-US', { weekday: 'long' });
      const formattedDateOnly = `${dayOfWeek}, ${months[appointmentDate.getMonth()]} ${ordinal(appointmentDate.getDate())}`;

      $.cookie('mm-virtual-date', formattedDateOnly, { expires: expirationDate });
      $.cookie('mm-virtual-raw-date', dateValue, { expires: expirationDate });

      $('.selected-date-text').text(formattedDateOnly);
      checkBookingReady();
    });

    let isTriggering = false;

    $(document).on('click', '.time-slot', function () {
      if (isTriggering) return;

      $('.time-slot').removeClass('active');
      $(this).addClass('active');

      const hour = $(this).data('hour');
      const minute = $(this).data('minute');
      const realSlot = $(`.xdsoft_time[data-hour="${hour}"][data-minute="${minute}"]`);

      if (realSlot.length) {
        isTriggering = true;
        realSlot.trigger('click');
        isTriggering = false;
      }
    });

    $(document).on('click', '.btn--time-select__wrap .btn--select', function () {
      const activeSlot = $('.time-slot.active');
      if (!activeSlot.length) return;

      const hour = Number(activeSlot.data('hour'));
      const label = activeSlot.text().trim();
      const selectedTime = `${label}${hour === 11 ? 'am' : 'pm'}`;

      $.cookie('mm-virtual-time', selectedTime, { expires: expirationDate });

      $('.selected-time-text').text(selectedTime);
      checkBookingReady();
    });

    $(document).on('click', '.service-section .btn-next', function () {
      const appointmentDate = $('#datetimepicker').datetimepicker('getValue');
      if (!appointmentDate) return;

      renderSummary();

      const bookingFormData = getBookingFormData();

      $('#source').val(bookingFormData.source);
      $('#appointment_type').val(bookingFormData.appointment_type);
      $('#pick_a_service').val(bookingFormData.pick_a_service);
      $('#service_when').val(bookingFormData.service_when);
      $.cookie('mm-virtual-iso-datetime', new Date(appointmentDate).toISOString(), { expires: expirationDate });
      setVirtualBookingSourceCookie();

      $('#service-section').removeClass('active');
      $('#details-section').addClass('active');
      $('.breadcrumb-Availability').addClass('complete');
      $('.breadcrumb-Details').addClass('active');
      $('.breadcrumbs-progress-bar').css('width', '75%');

      $('.details-section .additional-information__form').remove();

      if ($.cookie('mm-virtual-appointment') === 'Request a Service') {
        $('.additional-service').first().clone().insertAfter('.personal-information__form');
      } else {
        $('.additional-consult').first().clone().insertAfter('.personal-information__form');
      }
    });

    $(document).on('click', '#next-button', function () {
      setVirtualBookingSourceCookie();
    });

    $(document).on('click', '.reset-button', function () {
      $('.location-container').removeClass('active');
      $('#service-section').addClass('active');
      $('.breadcrumbs button').removeClass('complete active');
      $('.breadcrumb-Services').addClass('active');
      $('.breadcrumbs-progress-bar').css('width', '25%');

      const newUrl = window.location.href.replace(/(\?|&)contact_posted=true/, '');
      history.replaceState({}, document.title, newUrl);

      $('.details-section .additional-information__form').remove();
      $('.service-dropdown').val('');
      $('.selected-date-text').text('Select a date');
      $('.selected-time-text').text('Select a time');
      $('.btn--continue').removeClass('active').prop('disabled', true);
    });

    saveInputValue('#first-name', 'mm-customer-fname');
    saveInputValue('#last-name', 'mm-customer-lname');
    saveInputValue('#email', 'mm-customer-email');
    saveInputValue('#mobile', 'mm-customer-mobile');

    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get('contact_posted') === 'true') {
      $('.location-container').removeClass('active');
      $('#review-section').addClass('active');
      $('.breadcrumbs button').addClass('complete active');
      $('.breadcrumbs-progress-bar').css('width', '100%');

      renderSummary();
    }

    $('.service-dropdown').val('');
    $('.selected-date-text').text('Select a date');
    $('.selected-time-text').text('Select a time');
    $('.btn--continue').removeClass('active').prop('disabled', true);
  });

  jQuery('#datetimepicker').datetimepicker({
    inline: true,
    defaultTime: '12:00',
    defaultDate: '+1970/01/02',
    minDate: 0,
    timepickerScrollbar: false,
    lang: 'en',
    format: 'd/m/Y',
    scrollMonth: false,
    scrollInput: false,
    allowTimes: [
      '11:00', '11:30', '12:00', '12:30',
      '1:00', '1:30', '2:00', '2:30',
      '3:00', '3:30', '4:00', '4:30', '5:00'
    ],
    onGenerate: function () {
      const timeContainer = jQuery('.time-slots');
      timeContainer.empty();

      jQuery('.xdsoft_time').each(function () {
        const timeText = jQuery(this).text().trim();
        if (!timeText) return;

        const hour = jQuery(this).attr('data-hour');
        const minute = jQuery(this).attr('data-minute');
        const currentClass = jQuery(this).hasClass('xdsoft_current') ? 'active' : '';

        timeContainer.append(`
          <button
            type="button"
            class="time-slot ${currentClass}"
            data-time="${timeText}"
            data-hour="${hour}"
            data-minute="${minute}">
            ${timeText}
          </button>
        `);
      });
    }
  });
})();
